import { Link } from "react-router-dom";
import { SITE } from "../config";
import { Logo } from "./Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-ink-900 text-ink-300">
      <div
        aria-hidden
        className="h-[3px] bg-gradient-to-r from-brand-600 via-violet-500 to-brand-600"
      />
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
        <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
          <div>
            <Logo size="sm" variant="dark" className="mb-3" />
            <p className="text-sm text-ink-400">{SITE.tagline}</p>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-semibold text-ink-100">Product</h4>
            <ul className="space-y-2 text-sm text-ink-400">
              <li>
                <Link to="/features" className="transition hover:text-ink-100">
                  Features
                </Link>
              </li>
              <li>
                <Link
                  to="/integrations"
                  className="transition hover:text-ink-100"
                >
                  Integrations
                </Link>
              </li>
              <li>
                <Link to="/security" className="transition hover:text-ink-100">
                  Security
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="transition hover:text-ink-100">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>
          <div className="hidden lg:block">
            <h4 className="mb-3 text-sm font-semibold text-ink-100">
              Solutions
            </h4>
            <ul className="space-y-2 text-sm text-ink-400">
              <li>
                <Link
                  to="/solutions/dtc"
                  className="transition hover:text-ink-100"
                >
                  Direct-to-consumer
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions/b2b"
                  className="transition hover:text-ink-100"
                >
                  B2B & wholesale
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions/marketplaces"
                  className="transition hover:text-ink-100"
                >
                  Marketplaces
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions/subscription"
                  className="transition hover:text-ink-100"
                >
                  Subscription
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-semibold text-ink-100">Company</h4>
            <ul className="space-y-2 text-sm text-ink-400">
              <li>
                <Link to="/about" className="transition hover:text-ink-100">
                  About
                </Link>
              </li>
              <li>
                <Link to="/developers" className="transition hover:text-ink-100">
                  Developers
                </Link>
              </li>
              <li>
                <Link
                  to="/customers"
                  className="transition hover:text-ink-100"
                >
                  In use at Zopping
                </Link>
              </li>
              <li>
                <Link to="/contact" className="transition hover:text-ink-100">
                  Talk to us
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-semibold text-ink-100">
              Get started
            </h4>
            <ul className="space-y-2 text-sm text-ink-400">
              <li>
                <a href={SITE.appUrl} className="transition hover:text-ink-100">
                  Start free
                </a>
              </li>
              <li>
                <a
                  href={SITE.appUrl}
                  className="transition hover:text-ink-100"
                >
                  Sign in
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 flex flex-wrap items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-ink-500">
          <span>
            © {year}{" "}
            <span className="bg-gradient-to-br from-brand-400 to-violet-400 bg-clip-text font-semibold text-transparent">
              Zop
            </span>
            <span className="font-semibold text-ink-300">Desk</span>. All rights reserved.
          </span>
          <span className="flex gap-4 text-ink-500">
            <Link to="/privacy" className="hover:text-ink-300">Privacy</Link>
            <Link to="/terms" className="hover:text-ink-300">Terms</Link>
            <span>In beta</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
